<div class="container">
    <div class="config-tab-title-area">
        <smart-icon name="detail-setting" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">{{'dashboard.tile_settings' | stringLiterals}}</span>
    </div>
    <form [formGroup]="contentForm" class="margin-body">
        <div class="tam-form-field" [ngClass]="{'has-error': name.invalid}">
            <div class="tam-form-label">
                <span>{{'dashboard.tile_name' | stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <input type="text" class="tam-textbox" formControlName="name" (input)="changName()">
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                {{'dashboard.dashboard_name_exceed_maximum' | stringLiterals: '64'}}
            </div>
        </div>
        <div class="tam-form-field" [ngClass]="{'has-error': description.invalid}">
            <div class="tam-form-label">
                <span>{{'dashboard.tile_description' | stringLiterals}}</span>
            </div>
            <textarea class="tam-textbox textarea" formControlName="description"
                (input)="changDescription()"></textarea>
            <div class="tam-form-help" *ngIf="description.invalid && description.errors['maxlength']">
                {{'dashboard.dashboard_description_exceeds_the_maximum_of_128_characters_allowed' | stringLiterals}}
            </div>
        </div>
    </form>
    <div class="tam-form-field margin-body" [hidden]="config.hideFocusSetting">
        <tam-focus-setting [config]="focusSettingConfig"></tam-focus-setting>
    </div>
    <div class="tam-form-help margin-body" *ngIf="errorMsg">
        {{errorMsg}}
    </div>
</div>